export const POPULAR_STOPS = 'popular-stops'
export const PLACE_SEARCH_RESULTS = 'place-search-results'
export const MMI_KEY='mmi-key'
export const ADD_REST_STOP = 'add-rest-stop'
export const DELETE_STOP = 'delete-rest-stop'

